import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_PATH,
  timeout: 30000,
});

export { axiosInstance }